import { render, staticRenderFns } from "./BannerSortOrder.vue?vue&type=template&id=bab7f850&scoped=true&lang=pug"
import script from "./BannerSortOrder.vue?vue&type=script&lang=js"
export * from "./BannerSortOrder.vue?vue&type=script&lang=js"
import style0 from "./BannerSortOrder.vue?vue&type=style&index=0&id=bab7f850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab7f850",
  null
  
)

export default component.exports